// extracted by mini-css-extract-plugin
export default {"VolumeControl":"VolumeControl-module--VolumeControl--IM4sy"};